export default "__VITE_ASSET__acc505dd__"